<template>
  <q-card style="min-width: 350px">
    <q-card-section>
      <div class="text-h6">Randevu Tarihi Degistir</div>
    </q-card-section>

    <q-card-section class="q-pt-none">
      <q-form class="q-gutter-md">
        <!-- Appointment Date -->
        <q-input v-model="appointmentDate" filled label="Randevu Gunu">
          <template #append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                ref="qDateProxy"
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date v-model="appointmentDate" mask="DD-MM-YYYY">
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Kapat" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>

        <!-- Appointment Start Time -->
        <q-input
          v-model="appointmentStart"
          filled
          label="Randevu Baslangic Saati"
        >
          <template #append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                ref="qDateProxy"
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-time v-model="appointmentStart" format24h>
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Kapat" color="primary" flat />
                  </div>
                </q-time>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>

        <!-- Appointment End Time -->
        <q-input v-model="appointmentEnd" filled label="Randevu Bitis Saati">
          <template #append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                ref="qDateProxy"
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-time v-model="appointmentEnd" format24h>
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Kapat" color="primary" flat />
                  </div>
                </q-time>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>

        <!-- Appointment Send E-Mail ? -->
        <q-checkbox
          v-model="appointmentSendEmail"
          label="E-Posta Gonder"
          color="teal"
        />

        <!-- Appointment Send Sms ? -->
        <q-checkbox
          v-model="appointmentSendSms"
          label="SMS Gonder"
          color="teal"
        />
      </q-form>
    </q-card-section>

    <q-card-actions align="right" class="text-primary">
      <q-btn v-close-popup flat label="Vazgec" color="red" />
      <q-btn
        v-close-popup
        flat
        label="Guncelle"
        color="secondary"
        @click="onSubmit"
      />
    </q-card-actions>
  </q-card>
</template>

<script>
import { useQuasar } from 'quasar'
import { ref, toRefs, inject } from 'vue'
import axios from 'axios'
import moment from 'moment'
import * as eventNames from '../../utils/events'
import * as notify from '../../utils/notification'

export default {
  props: {
    appointment: Object,
  },
  setup(props) {
    const $q = useQuasar()
    const emitter = inject('emitter')
    let { appointment } = toRefs(props)

    // appointment reschedule form inputs
    const appointmentDate = ref(null)
    const appointmentStart = ref(null)
    const appointmentEnd = ref(null)
    const appointmentSendEmail = ref(true)
    const appointmentSendSms = ref(true)

    /*
      Set Appointment's Existing times to the form inputs
    */
    appointmentDate.value = moment(appointment.value.start).format('DD-MM-YYYY')
    appointmentStart.value = moment(appointment.value.start).format('HH:mm')
    appointmentEnd.value = moment(appointment.value.end).format('HH:mm')

    function prepareRequestPayload() {
      let appDate = moment(appointmentDate.value, 'DD-MM-YYYY')
      let startTime = moment(appointmentStart.value, 'HH:mm')
      let endTime = moment(appointmentEnd.value, 'HH:mm')

      return {
        appointmentStart: appDate
          .set({
            hour: startTime.get('hour'),
            minute: startTime.get('minute'),
          })
          .toISOString(),
        appointmentEnd: appDate
          .set({
            hour: endTime.get('hour'),
            minute: endTime.get('minute'),
          })
          .toISOString(),
        sendEmail: appointmentSendEmail.value,
        sendSms: appointmentSendSms.value
      }
    }

    return {
      appointmentDate,
      appointmentStart,
      appointmentEnd,
      appointmentSendEmail,
      appointmentSendSms,
      prepareRequestPayload,
      onSubmit() {
        axios
          .post(
            `/appointments/${appointment.value.id}/reschedule`,
            prepareRequestPayload()
          )
          .then(() => {
            $q.notify(notify.success('Randevu tarihi guncellendi.'))
            emitter.emit(eventNames.REFRESH_APPOINTMENTS)
          })
          .catch(() => {
            $q.notify(notify.warning('Randevu tarihi guncellenemedi.'))
          })
      },
    }
  },
}
</script>
